"use strict";

var _moduleLocalization = require("@eig-builder/module-localization");

_moduleLocalization.Localizations.append({
  helpers: {
    gmbWithCustomFocusNavigation: {
      title: {
        reviewManagement: 'Review Management',
        businessListing: 'Google My Business Listing'
      },
      postReply: 'Post Reply',
      kebabMenu: {
        copyReviewLink: 'Copy Review Link',
        flagReview: 'Flag Review',
        deleteYourReply: 'Delete Your Reply'
      }
    }
  }
});